import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

export enum HeaderType {
  Generic = 'generic',
  FloatingRG = 'floating-rg',
  FloatingSM = 'floating-sm',
  HomeSM = 'home-sm',
  HomeLG = 'home-lg',
  Results = 'results',
  Reservation = 'reservation',
  CardSelected = 'card-selected',
  CardBrand = 'card-brand',
}

export enum HeaderWidgetType {
  Back = 'back',
  Alert = 'alert',
  Support = 'support',
  MyTrips = 'my-trips',
  InputSearch = 'input-search',
  Rappi = 'rappi',
  SearchInfo = 'search-info',
  ReservationInfo = 'reservation-info',
  Edit = 'edit',
  CardSelected = 'card-selected',
  CardBrand = 'card-brand',
  Close = 'close',
  Title = 'title',
  Clean = 'clean',
}

export enum HeaderWidgetComponentType {
  ButtonFloating = 'button-floating',
  Label = 'label',
  Title = 'title',
  Tab = 'tab',
  Card = 'card',
  SearchDataInfo = 'search-data-info', 
  ReservationDataInfo = 'reservation-data-info', 
  InputSearch = 'input-search',
  ButtonIcon = 'button-icon',
}

export enum HeaderSupportType {
  Device = 'Device',
  Whatsapp = 'Whatsapp'
}

export interface HeaderWidget {
  Type: HeaderWidgetType;
  Icon: Icon;
  AvailableIn: HeaderType[];
}

export interface HeaderWidgetConfig {
  Type: HeaderWidgetType;
  IsActivated?: boolean;
  Label?: string;
  Notifications?: number;
  Logo?: string;
  Link?: string;
  Loading?: boolean;
  SearchDataInfo?: HeaderSearchDataInfoWidget;
  ReservationInfo?: HeaderReservationInfoWidget;
  LabelAlign?: LabelAlignType;
  LabelIcon?: Icon;
  SupportType?: HeaderSupportType;
}

export type LabelAlignType = 'center' | 'left' | 'right';

export interface HeaderReservationInfoWidget {
  Title: string;
  Subtitle?: string;
}

export interface HeaderSearchDataInfoWidget {
  Titles: HeaderSearchDataInfoText[];
  Dates: string;
  Subtitles: HeaderSearchDataInfoText[];
}

export interface HeaderSearchDataInfoText {
  Icon?: Icon;
  Text: string;
}

export const HeaderWidgetsAvailable: HeaderWidget[] = [
  {
    Type: HeaderWidgetType.Back,
    Icon: Icon.ChevronLeft,
    AvailableIn: [
      HeaderType.FloatingRG,
      HeaderType.FloatingSM,
      HeaderType.Results,
      HeaderType.Reservation,
      HeaderType.Generic,
    ]
  },
  {
    Type: HeaderWidgetType.Title,
    Icon: null,
    AvailableIn: [
      HeaderType.Generic,
    ]
  },
  {
    Type: HeaderWidgetType.Close,
    Icon: Icon.Close,
    AvailableIn: [
      HeaderType.Generic,
    ]
  },
  {
    Type: HeaderWidgetType.InputSearch,
    Icon: null,
    AvailableIn: [
      HeaderType.FloatingSM,
    ]
  },
  {
    Type: HeaderWidgetType.Support,
    Icon: Icon.Whatsapp,
    AvailableIn: [
      HeaderType.FloatingRG,
      HeaderType.FloatingSM,
      HeaderType.HomeSM,
      HeaderType.HomeLG,
      HeaderType.Reservation,
    ]
  },
  {
    Type: HeaderWidgetType.Alert,
    Icon: Icon.Notification,
    AvailableIn: [
      HeaderType.FloatingRG,
      HeaderType.FloatingSM,
      HeaderType.HomeSM,
      HeaderType.HomeLG,
    ]
  },
  {
    Type: HeaderWidgetType.MyTrips,
    Icon: Icon.Packages,
    AvailableIn: [
      HeaderType.FloatingRG,
      HeaderType.FloatingSM,
      HeaderType.HomeSM,
      HeaderType.HomeLG,
      HeaderType.Generic,
    ]
  },
  {
    Type: HeaderWidgetType.Rappi,
    Icon: Icon.MustacheFlat,
    AvailableIn: [
      HeaderType.HomeSM,
      HeaderType.HomeLG,
    ]
  },
  {
    Type: HeaderWidgetType.SearchInfo,
    Icon: null,
    AvailableIn: [
      HeaderType.Results,
    ]
  },
  {
    Type: HeaderWidgetType.Edit,
    Icon: Icon.EditOutline,
    AvailableIn: [
      HeaderType.Results,
    ]
  },
  {
    Type: HeaderWidgetType.Clean,
    Icon: null,
    AvailableIn: [
      HeaderType.Generic,
    ]
  },
  {
    Type: HeaderWidgetType.CardSelected,
    Icon: Icon.Check,
    AvailableIn: [
      HeaderType.CardSelected
    ]
  },
  {
    Type: HeaderWidgetType.CardBrand,
    Icon: null,
    AvailableIn: [
      HeaderType.CardBrand
    ]
  },
  {
    Type: HeaderWidgetType.ReservationInfo,
    Icon: null,
    AvailableIn: [
      HeaderType.Reservation
    ]
  },
];
